import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography, Paper } from "@material-ui/core";
import { fetchUsuario } from "../../../../actions/usuarios/usuarios";
import { useEffect } from "react";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import ToolbarXLSPDF from "../../../compartidos/ToolbarXLSPDF";
import IconEstado from "../../../autorizaciones/UI/IconEstado";
import moment from "moment";
import { cleanDocumentacionReclamos, setSolicitudReclamo } from "../../../../actions/reclamos/reclamosActions";
import { AddButtonReclamoEfector } from "./AddButtonReclamoEfector";
import { TraerReclamoPorIdEfector } from "../../../../actions/reclamos/reclamosEfectorActions";
import { IconInfo } from "../IconInfo";
import InfoHistorialIcon from "../../../autorizaciones/UI/InfoHistorialIcon";
import { ImpresionReclamoEfector } from "./StepperIngreso/ImpresionReclamoEfector";
import { ModalDetalleReclamoEfector } from "./ModalDetalleReclamo/ModalDetalleReclamoEfector";
import { ModalTrackingReclamoEfector } from "./ModalTrackingReclamo/ModalTrackingReclamoEfector";

export const IngresoReclamosEfector = (props) => {

  const dispatch = useDispatch();
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] =
    useState(false);
  const [idClave, setIdClave] = useState(false);
  const [descripcion, setDescripcion] = useState(false);
  const { dataEfector, reclamos
  } = useSelector((state) => state.reclamos);
  const { areaFisicaUsuario } = useSelector((state) => state.areasFisicas);
  const { usuarioSeleccionado } = useSelector((state) => state.usuarios);

  useEffect(() => {
    dispatch(fetchUsuario(areaFisicaUsuario?.idUsuario));
    dispatch(cleanDocumentacionReclamos());
  }, [dispatch]);


  useEffect(() => {
    dispatch(TraerReclamoPorIdEfector(dataEfector?.idEfectorFacturacion));
  }, [dataEfector]);


  return (
    <>
      {openModalInfo && (
        <ModalTrackingReclamoEfector
          open={openModalInfo}
          onClose={() => setOpenModalInfo(false)}
          idClave={idClave}
          descripcion={descripcion}
        />
      )}
      {openModalHistorialCambios && (
        <ModalDetalleReclamoEfector
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          disabled={true}
        />
      )}

      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} md={11} style={{ paddingLeft: 0, marginBottom: 10 }}>
          <AddButtonReclamoEfector
            //handleSave={handleSave}
            dataEfector={dataEfector}
            idArea={areaFisicaUsuario}
            usuario={usuarioSeleccionado}
          />
        </Grid>

        <Grid item xs={12} md={11} style={{ paddingLeft: 0, marginTop: 20 }}>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            component={Paper}
            spacing={2}
          >
            <Grid item>
              <Typography variant="subtitle1" style={{ paddingLeft: 20 }}>
                "Listado de casos"
              </Typography>
            </Grid>
            <Grid item>
              <ToolbarXLSPDF
              //handleExportExcel={() => dispatch(generateExcelMesaEntrada(dataContrato?.idEfectorFacturacion))}
              //handleGeneratePdf={() => dispatch(generatePDFMesaEntrada(dataContrato?.idEfectorFacturacion))}
              />
            </Grid>
            <Grid item xs={12}>
              <TableGeneric
                data={reclamos}
                columns={[
                  {
                    label: "",
                    id: "",
                    sort: false,
                    customBody: (item) => (
                      <InfoHistorialIcon
                        onClick={() => {
                          setOpenModalInfo(true);
                          setIdClave(item?.id);
                          setDescripcion(`${item?.descripcion}`);
                        }}
                      />
                    ),
                  },

                  {
                    label: "Semáforo",
                    customBody: (item) => (
                      <IconEstado
                        useColorTable={true}
                        texto={item?.letraUrgente}
                        backgroundColor={item?.colorUrgente}
                        descripcion={item?.descripcionUrgente}
                      />
                    ),
                  },
                  {
                    label: "Estado",
                    customBody: (item) => (
                      <IconEstado
                        useColorTable={true}
                        texto={item?.letraEstado}
                        backgroundColor={item?.color}
                        descripcion={item?.descripcionUrgente}
                      />
                    ),
                  },
                  {
                    label: "Nro",
                    id: "id",
                    sort: true,
                  },
                  {
                    label: "Fecha Carga",
                    id: "fechaCarga",
                    customBody: (item) =>
                      moment(item.fechaCarga).format("DD/MM/YYYY"),
                  },
                  {
                    label: "Tipo",
                    id: "descripcionTipoReclamo",
                    sort: true,
                  },
                  {
                    label: "Origen",
                    id: "descripcionTipoOrigen",
                    sort: true,
                  },

                  {
                    label: "Categoría",
                    id: "descripcionCategoriaReclamo",
                    sort: true,
                  },
                  {
                    label: "Área derivado",
                    id: "derivado",
                    sort: true,
                  },
                  {
                    label: "Sub Area",
                    id: "subDerivado",
                    sort: true,
                  },
                  {
                    label: "Origen del error",
                    id: "descripcionTipoErrorReclamo",
                    sort: true,
                  },
                  {
                    label: "Información",
                    id: "",
                    sort: false,
                    customBody: (item) => (
                      <IconInfo
                        onClick={() => {
                          dispatch(setSolicitudReclamo(item));
                          setOpenModalHistorialCambios(true);
                        }}
                      />
                    ),
                  },
                  {
                    label: "Imprimir Comprobante",
                    customBody: (item) => (
                      <ImpresionReclamoEfector reclamoImp={item} />
                    ),
                  },
                ]}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
